import './preflight.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import Home from 'src/pages/home';

import '@arco-design/web-react/dist/css/arco.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<Home />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals